import React, { useRef } from 'react';

import { iconsSources } from '../../helpers/icons';

import styles from './Message.module.css';
import { hideNumber } from '../../helpers/titreHelper';
import { useScrollText } from '../../hooks/useScrollText';

const Message = ({
  className,
  message,
  withCircles,
  setDelay,
  messagesWrapper,
}) => {
  const contentRef = useRef();
  const contentContainerRef = useRef();

  useScrollText(
    contentRef,
    contentContainerRef,
    message?.content,
    setDelay,
    messagesWrapper
  );

  const errorHandler = (e) => {
    e.target.src = iconsSources[message?.channel];
  };

  return (
    <div className={className}>
      <div className={styles.wrapper}>
        {message?.content && (
          <>
            <div className={styles.avatar}>
              <img
                src={
                  (message?.image !== '1' && message?.image) ||
                  iconsSources[message?.channel]
                }
                alt={message?.author}
                onError={errorHandler}
              />
            </div>
            <div className={styles.content}>
              <div className={styles.name}>
                <div>
                  {message?.author || hideNumber(message?.senderNumber)}
                </div>
              </div>
              <div className={styles.textWrapper} ref={contentContainerRef}>
                <div className={styles.text} ref={contentRef}>
                  {message?.content}
                </div>
              </div>
            </div>
          </>
        )}
        {withCircles && (
          <>
            <span className={styles.buble1}></span>
            <span className={styles.buble2}></span>
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(Message);
